export const FONT_SIZE_PREFIX = "font-size";
export const LINE_HEIGHT_SPACING = "line-height";
export const LETTER_SPACING_PREFIX = "letter-spacing";

export const rawFontSizes = {
  0: "10px",
  1: "11px",
  2: "12px",
  3: "13px",
  4: "14px",
  5: "15px",
  6: "16px",
  7: "17px",
  8: "18px",
  9: "20px",
  10: "24px",
  11: "28px",
  12: "32px",
  13: "40px",
  14: "48px",
};

const fontFamily = "Open Sans";

export const rawFonts = {
  h1: `600 28px/42px ${fontFamily}, sans-serif;`,
  h2: `600 24px/36px ${fontFamily}, sans-serif;`,
  h3: `600 20px/30px ${fontFamily}, sans-serif;`,
  h4: `600 16px/24px ${fontFamily}, sans-serif;`,
  body1: `14px/20px ${fontFamily}, sans-serif;`,
  body2: `12px/18px ${fontFamily}, sans-serif;`,
  body3: `10px/16px ${fontFamily}, sans-serif;`,
  body4: `8px/12px ${fontFamily}, sans-serif;`,
  body1SemiBold: `600 14px/20px ${fontFamily}, sans-serif;`,
  body2SemiBold: `600 12px/18px ${fontFamily}, sans-serif;`,
  body3SemiBold: `600 10px/16px ${fontFamily}, sans-serif;`,
  body4SemiBold: `600 8px/12px ${fontFamily}, sans-serif;`,
};

export const rawLineHeights = {
  // WARN: Found em line-height in components.
  0: "16px",
  1: "18px",
  2: "20px",
  3: "31px",
  4: "32px",
};

export const rawLetterSpacings = {};

export type Fonts = {
  [key in keyof typeof rawFonts]: string;
} & {
  raw: Record<keyof typeof rawFonts, string>;
};

export type FontSizes = {
  [key in keyof typeof rawFontSizes]: string;
} & {
  raw: Record<keyof typeof rawFontSizes, string>;
};

export type LetterSpacings = {
  [key in keyof typeof rawLetterSpacings]: string;
} & {
  raw: Record<keyof typeof rawLetterSpacings, string>;
};

export type LineHeights = {
  [key in keyof typeof rawLineHeights]: string;
} & {
  raw: Record<keyof typeof rawLineHeights, string>;
};
